import { useContext } from 'react';
import { SessionContext, type SessionContextValue } from '../contexts/SessionContext';

// Reads the app-wide session from SessionContext. Returns { session,
// isLoaded, signOut }. Throws if rendered outside <SessionProvider> so a
// missing provider fails loudly instead of silently reporting "signed out".
export function useSession(): SessionContextValue {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error('useSession must be used within a <SessionProvider>');
  }
  return ctx;
}
